const NOTIFY_P3_KEY = "hospitol.emergency.notifyP3";

export function isEmergencyP3NotificationsEnabled(): boolean {
  return localStorage.getItem(NOTIFY_P3_KEY) === "1";
}

export function setEmergencyP3NotificationsEnabled(enabled: boolean): void {
  localStorage.setItem(NOTIFY_P3_KEY, enabled ? "1" : "0");
}
